<ng-container *ngIf="viewState === viewStates.EDIT">
  <ng-container *ngIf="attachments.length == 0">
    <input
      #fileUpload
      type="file"
      class="file-input"
      (change)="onFileChange($event)"
      [accept]="allowedFileTypes" />
    <div
      class="file-upload p-3 text-center rounded-1"
      [ngClass]="[
        disabled ? 'disabled' : '',
        isUploading ? 'disabled' : '',
        dropzoneActive ? 'dropzone' : ''
      ]"
      (dragleave)="$event.preventDefault(); toggleDropZone(false); (false)"
      (dragover)="$event.preventDefault(); toggleDropZone(true); (false)"
      (dragend)="$event.preventDefault(); toggleDropZone(false); (false)"
      (drop)="handleDrop($event); (false)"
      (click)="onUploadButtonClick()">
      <p>Click here or drag file here to upload</p>
      <div class="btn btn-tertiary"><i class="bi bi-upload"></i></div>
    </div>
    <ng-container *ngIf="errorMsg">
      <ngb-alert [type]="'danger'" (closed)="this.errorMsg = ''">{{
        errorMsg
      }}</ngb-alert>
    </ng-container>
    <div *ngIf="uploadingItems" class="uploadItems">
      <div class="row" *ngFor="let item of uploadingItems | keyvalue">
        <div class="col-xs-12">
          {{ item.value.name }}
          <ngb-progressbar
            [value]="item.value.progress"
            [animated]="true"></ngb-progressbar>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>
<ng-container
  *ngIf="
    viewState === viewStates.EDIT ||
    viewState === viewStates.SUBMITTED ||
    viewState == viewStates.GRADED
  ">
  <ng-container *ngIf="attachments.length > 0">
    <app-file-list
      [fileList]="attachments"
      (deletedFile)="deleteAttachment($event)"
      [canDelete]="viewState === viewStates.EDIT"
      [skipApiCallOnDelete]="true"></app-file-list>
  </ng-container>
</ng-container>
<ng-container
  *ngIf="
    viewState === viewStates.PREVIEW ||
    (viewState === viewStates.SUBMITTED && attachments.length === 0)
  ">
  <app-file-upload #uploadComponent [disabled]="true" [style]="uploadStyle" />
</ng-container>
